var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.showTable
      ? _c(
          "div",
          { staticClass: "table-layout expanded" },
          [
            _c(
              "el-table",
              {
                ref: "contractImpInfoTable",
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.pageContractImpList,
                  height: _vm.tableHeight,
                  "expand-row-keys": _vm.expends,
                  "row-key": _vm.getRowKeys,
                  border: "",
                  "row-class-name": _vm.getRowClass
                },
                on: {
                  "expand-change": _vm.showManageDetail,
                  "selection-change": _vm.handleMainSelectionChange
                }
              },
              [
                _c("el-table-column", {
                  attrs: { type: "expand" },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(props) {
                        return [
                          _c(
                            "div",
                            {
                              staticClass: "sub-table-layout",
                              staticStyle: { padding: "20px 20px 20px 40px" }
                            },
                            [
                              props.row.subImpInfos != null &&
                              props.row.subImpInfos.length > 0
                                ? _c(
                                    "el-table",
                                    {
                                      staticStyle: { width: "100%" },
                                      attrs: {
                                        data: props.row.subImpInfos,
                                        border: "",
                                        "row-class-name":
                                          _vm.markSelectedRowClassName
                                      },
                                      on: {
                                        "selection-change":
                                          _vm.handleSelectionChange
                                      }
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          type: "selection",
                                          width: "40",
                                          align: "center",
                                          fixed: "left"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "htBh",
                                        null,
                                        _vm.assetCustFileds,
                                        _vm.assetFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "htBh",
                                                  "合同编号",
                                                  _vm.assetFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "htBh",
                                                  width: "220"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .htBh.validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .htBh
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .htBh
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row.htBh
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "skuId",
                                        null,
                                        _vm.assetCustFileds,
                                        _vm.assetFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "skuId",
                                                  "SKUID",
                                                  _vm.assetFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "skuId",
                                                  "render-header": _vm.setGoods
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .skuId.validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .skuId
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .skuId
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row.skuId
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "goodsTitle",
                                        null,
                                        _vm.assetCustFileds,
                                        _vm.assetFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "goodsTitle",
                                                  "商品名称",
                                                  _vm.assetFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: { prop: "goodsTitle" },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .goodsTitle.validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .goodsTitle
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .goodsTitle
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row
                                                                    .goodsTitle
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "innerCode",
                                        null,
                                        _vm.assetCustFileds,
                                        _vm.assetFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "innerCode",
                                                  "资产定义编码",
                                                  _vm.assetFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "innerCode",
                                                  width: "220"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .innerCode.validateOk
                                                          ? _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .innerCode,
                                                                  expression:
                                                                    "rows.row.innerCode"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                "background-color":
                                                                  "#edd28b",
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text",
                                                                title:
                                                                  rows.row
                                                                    .validateInfo
                                                                    .innerCode
                                                                    .errorMsg
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .innerCode
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  _vm.assetChangeEvent(
                                                                    rows.row
                                                                  )
                                                                },
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "innerCode",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          : _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .innerCode,
                                                                  expression:
                                                                    "rows.row.innerCode"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .innerCode
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  _vm.assetChangeEvent(
                                                                    rows.row
                                                                  )
                                                                },
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "innerCode",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "name",
                                        null,
                                        _vm.assetCustFileds,
                                        _vm.assetFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "name",
                                                  "资产名称",
                                                  _vm.assetFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "name",
                                                  width: "260"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .name.validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .name
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .name
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row.name
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "assetTitle",
                                        null,
                                        _vm.assetCustFileds,
                                        _vm.assetFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "assetTitle",
                                                  "资产描述全称",
                                                  _vm.assetFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "assetTitle",
                                                  width: "260"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .assetTitle.validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .assetTitle
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .assetTitle
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row
                                                                    .assetTitle
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "innerDevcCode",
                                        null,
                                        _vm.assetCustFileds,
                                        _vm.assetFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "innerDevcCode",
                                                  "资产分类编码",
                                                  _vm.assetFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "innerDevcCode",
                                                  width: "180"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .innerDevcCode
                                                          .validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .innerDevcCode
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .innerDevcCode
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row
                                                                    .innerDevcCode
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "brandName",
                                        null,
                                        _vm.assetCustFileds,
                                        _vm.assetFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "brandName",
                                                  "品牌",
                                                  _vm.assetFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "brandName",
                                                  width: "180"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .brandName.validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .brandName
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .brandName
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row
                                                                    .brandName
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "theUnit",
                                        null,
                                        _vm.assetCustFileds,
                                        _vm.assetFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "theUnit",
                                                  "单位",
                                                  _vm.assetFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "theUnit",
                                                  width: "180"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .theUnit.validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .theUnit
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .theUnit
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row
                                                                    .theUnit
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "model",
                                        null,
                                        _vm.assetCustFileds,
                                        _vm.assetFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "model",
                                                  "型号",
                                                  _vm.assetFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "model",
                                                  width: "200"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .model.validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .model
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .model
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row.model
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "fixedSpec",
                                        null,
                                        _vm.assetCustFileds,
                                        _vm.assetFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "fixedSpec",
                                                  "规格",
                                                  _vm.assetFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "fixedSpec",
                                                  width: "200"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .fixedSpec.validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .fixedSpec
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .fixedSpec
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row
                                                                    .fixedSpec
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "bizAreaName",
                                        null,
                                        _vm.assetCustFileds,
                                        _vm.assetFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "bizAreaName",
                                                  "区域名称",
                                                  _vm.assetFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "bizAreaName",
                                                  width: "180"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .bizAreaName
                                                          .validateOk
                                                          ? _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .bizAreaName,
                                                                  expression:
                                                                    "rows.row.bizAreaName"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                "background-color":
                                                                  "#edd28b",
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text",
                                                                title:
                                                                  rows.row
                                                                    .validateInfo
                                                                    .bizAreaName
                                                                    .errorMsg
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .bizAreaName
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  _vm.bizAreaChangeEvent(
                                                                    rows.row
                                                                  )
                                                                },
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "bizAreaName",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          : _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .bizAreaName,
                                                                  expression:
                                                                    "rows.row.bizAreaName"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .bizAreaName
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  _vm.bizAreaChangeEvent(
                                                                    rows.row
                                                                  )
                                                                },
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "bizAreaName",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "bizAreaCode",
                                        null,
                                        _vm.assetCustFileds,
                                        _vm.assetFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "bizAreaCode",
                                                  "区域编码",
                                                  _vm.assetFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "bizAreaCode",
                                                  width: "180"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .bizAreaCode
                                                          .validateOk
                                                          ? _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .bizAreaCode,
                                                                  expression:
                                                                    "rows.row.bizAreaCode"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                "background-color":
                                                                  "#edd28b",
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text",
                                                                title:
                                                                  rows.row
                                                                    .validateInfo
                                                                    .bizAreaCode
                                                                    .errorMsg
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .bizAreaCode
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  _vm.bizAreaChangeEvent(
                                                                    rows.row
                                                                  )
                                                                },
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "bizAreaCode",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          : _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .bizAreaCode,
                                                                  expression:
                                                                    "rows.row.bizAreaCode"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .bizAreaCode
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  _vm.bizAreaChangeEvent(
                                                                    rows.row
                                                                  )
                                                                },
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "bizAreaCode",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "price",
                                        null,
                                        _vm.assetCustFileds,
                                        _vm.assetFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "price",
                                                  "含税价(元)",
                                                  _vm.assetFieldMap
                                                ),
                                                align: "right"
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "price",
                                                  width: "140",
                                                  align: "right"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .price.validateOk
                                                          ? _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .price,
                                                                  expression:
                                                                    "rows.row.price"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "align-right",
                                                              staticStyle: {
                                                                "background-color":
                                                                  "#edd28b",
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text",
                                                                title:
                                                                  rows.row
                                                                    .validateInfo
                                                                    .price
                                                                    .errorMsg
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row.price
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.commonChangeEvent,
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "price",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          : _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .price,
                                                                  expression:
                                                                    "rows.row.price"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "align-right",
                                                              staticStyle: {
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row.price
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.commonChangeEvent,
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "price",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "wrntPeriod",
                                        null,
                                        _vm.assetCustFileds,
                                        _vm.assetFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "wrntPeriod",
                                                  "质保期(月)",
                                                  _vm.assetFieldMap
                                                ),
                                                align: "right"
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "wrntPeriod",
                                                  width: "140",
                                                  align: "right"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .wrntPeriod.validateOk
                                                          ? _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .wrntPeriod,
                                                                  expression:
                                                                    "rows.row.wrntPeriod"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "align-right",
                                                              staticStyle: {
                                                                "background-color":
                                                                  "#edd28b",
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text",
                                                                title:
                                                                  rows.row
                                                                    .validateInfo
                                                                    .wrntPeriod
                                                                    .errorMsg
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .wrntPeriod
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.commonChangeEvent,
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "wrntPeriod",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          : _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .wrntPeriod,
                                                                  expression:
                                                                    "rows.row.wrntPeriod"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "align-right",
                                                              staticStyle: {
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .wrntPeriod
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.commonChangeEvent,
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "wrntPeriod",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "bizFormNames",
                                        null,
                                        _vm.assetCustFileds,
                                        _vm.assetFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "bizFormNames",
                                                  "经营业态",
                                                  _vm.assetFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "bizFormNames",
                                                  "render-header":
                                                    _vm.setBizFormNames
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .bizFormNames
                                                          .validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .bizFormNames
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .bizFormNames
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row
                                                                    .bizFormNames
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              props.row.asmblImpInfos != null &&
                              props.row.asmblImpInfos.length > 0
                                ? _c(
                                    "el-table",
                                    {
                                      staticStyle: {
                                        width: "100%",
                                        "margin-top": "5px"
                                      },
                                      attrs: {
                                        data: props.row.asmblImpInfos,
                                        border: "",
                                        "row-class-name":
                                          _vm.markSelectedRowClassName
                                      },
                                      on: {
                                        "selection-change":
                                          _vm.handleSelectionChange
                                      }
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          type: "selection",
                                          width: "40",
                                          align: "center",
                                          fixed: "left"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "htBh",
                                        null,
                                        _vm.asmblCustFileds,
                                        _vm.asmblFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "htBh",
                                                  "合同编号",
                                                  _vm.asmblFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "htBh",
                                                  width: "220"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .htBh.validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .htBh
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .htBh
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row.htBh
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "skuId",
                                        null,
                                        _vm.assetCustFileds,
                                        _vm.assetFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "skuId",
                                                  "SKUID",
                                                  _vm.assetFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "skuId",
                                                  "render-header": _vm.setGoods
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .skuId.validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .skuId
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .skuId
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row.skuId
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "goodsTitle",
                                        null,
                                        _vm.assetCustFileds,
                                        _vm.assetFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "goodsTitle",
                                                  "商品名称",
                                                  _vm.assetFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: { prop: "goodsTitle" },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .goodsTitle.validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .goodsTitle
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .goodsTitle
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row
                                                                    .goodsTitle
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "innerCode",
                                        null,
                                        _vm.asmblCustFileds,
                                        _vm.asmblFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "innerCode",
                                                  "组装件定义编码",
                                                  _vm.asmblFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "innerCode",
                                                  width: "220"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .innerCode.validateOk
                                                          ? _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .innerCode,
                                                                  expression:
                                                                    "rows.row.innerCode"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                "background-color":
                                                                  "#edd28b",
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text",
                                                                title:
                                                                  rows.row
                                                                    .validateInfo
                                                                    .innerCode
                                                                    .errorMsg
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .innerCode
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  _vm.asmblChangeEvent(
                                                                    rows.row
                                                                  )
                                                                },
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "innerCode",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          : _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .innerCode,
                                                                  expression:
                                                                    "rows.row.innerCode"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .innerCode
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  _vm.asmblChangeEvent(
                                                                    rows.row
                                                                  )
                                                                },
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "innerCode",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "name",
                                        null,
                                        _vm.asmblCustFileds,
                                        _vm.asmblFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "name",
                                                  "组装件名称",
                                                  _vm.asmblFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "name",
                                                  width: "260"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .name.validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .name
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .name
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row.name
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "assetTitle",
                                        null,
                                        _vm.asmblCustFileds,
                                        _vm.asmblFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "assetTitle",
                                                  "组装件描述全称",
                                                  _vm.asmblFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "assetTitle",
                                                  width: "260"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .assetTitle.validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .assetTitle
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .assetTitle
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row
                                                                    .assetTitle
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "brandName",
                                        null,
                                        _vm.asmblCustFileds,
                                        _vm.asmblFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "brandName",
                                                  "品牌",
                                                  _vm.asmblFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "brandName",
                                                  width: "180"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .brandName.validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .brandName
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .brandName
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row
                                                                    .brandName
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "theUnit",
                                        null,
                                        _vm.asmblCustFileds,
                                        _vm.asmblFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "theUnit",
                                                  "单位",
                                                  _vm.asmblFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "theUnit",
                                                  width: "180"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .theUnit.validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .theUnit
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .theUnit
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row
                                                                    .theUnit
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "model",
                                        null,
                                        _vm.asmblCustFileds,
                                        _vm.asmblFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "model",
                                                  "型号",
                                                  _vm.asmblFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "model",
                                                  width: "200"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .model.validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .model
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .model
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row.model
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "fixedSpec",
                                        null,
                                        _vm.asmblCustFileds,
                                        _vm.asmblFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "fixedSpec",
                                                  "规格",
                                                  _vm.asmblFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "fixedSpec",
                                                  width: "200"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .fixedSpec.validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .fixedSpec
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .fixedSpec
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row
                                                                    .fixedSpec
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "bizAreaName",
                                        null,
                                        _vm.asmblCustFileds,
                                        _vm.asmblFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "bizAreaName",
                                                  "区域名称",
                                                  _vm.asmblFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "bizAreaName",
                                                  width: "180"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .bizAreaName
                                                          .validateOk
                                                          ? _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .bizAreaName,
                                                                  expression:
                                                                    "rows.row.bizAreaName"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                "background-color":
                                                                  "#edd28b",
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text",
                                                                title:
                                                                  rows.row
                                                                    .validateInfo
                                                                    .bizAreaName
                                                                    .errorMsg
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .bizAreaName
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  _vm.bizAreaChangeEvent(
                                                                    rows.row
                                                                  )
                                                                },
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "bizAreaName",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          : _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .bizAreaName,
                                                                  expression:
                                                                    "rows.row.bizAreaName"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .bizAreaName
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  _vm.bizAreaChangeEvent(
                                                                    rows.row
                                                                  )
                                                                },
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "bizAreaName",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "bizAreaCode",
                                        null,
                                        _vm.asmblCustFileds,
                                        _vm.asmblFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "bizAreaCode",
                                                  "区域编码",
                                                  _vm.asmblFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "bizAreaCode",
                                                  width: "180"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .bizAreaCode
                                                          .validateOk
                                                          ? _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .bizAreaCode,
                                                                  expression:
                                                                    "rows.row.bizAreaCode"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                "background-color":
                                                                  "#edd28b",
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text",
                                                                title:
                                                                  rows.row
                                                                    .validateInfo
                                                                    .bizAreaCode
                                                                    .errorMsg
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .bizAreaCode
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  _vm.bizAreaChangeEvent(
                                                                    rows.row
                                                                  )
                                                                },
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "bizAreaCode",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          : _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .bizAreaCode,
                                                                  expression:
                                                                    "rows.row.bizAreaCode"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .bizAreaCode
                                                              },
                                                              on: {
                                                                change: function(
                                                                  $event
                                                                ) {
                                                                  _vm.bizAreaChangeEvent(
                                                                    rows.row
                                                                  )
                                                                },
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "bizAreaCode",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "price",
                                        null,
                                        _vm.asmblCustFileds,
                                        _vm.asmblFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "price",
                                                  "含税价(元)",
                                                  _vm.asmblFieldMap
                                                ),
                                                align: "right"
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "price",
                                                  width: "180",
                                                  align: "right"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .price.validateOk
                                                          ? _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .price,
                                                                  expression:
                                                                    "rows.row.price"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "align-right",
                                                              staticStyle: {
                                                                "background-color":
                                                                  "#edd28b",
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text",
                                                                title:
                                                                  rows.row
                                                                    .validateInfo
                                                                    .price
                                                                    .errorMsg
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row.price
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.commonChangeEvent,
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "price",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          : _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .price,
                                                                  expression:
                                                                    "rows.row.price"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "align-right",
                                                              staticStyle: {
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row.price
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.commonChangeEvent,
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "price",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "wrntPeriod",
                                        null,
                                        _vm.asmblCustFileds,
                                        _vm.asmblFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "wrntPeriod",
                                                  "质保期(月)",
                                                  _vm.asmblFieldMap
                                                ),
                                                align: "right"
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "wrntPeriod",
                                                  width: "180",
                                                  align: "right"
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .wrntPeriod.validateOk
                                                          ? _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .wrntPeriod,
                                                                  expression:
                                                                    "rows.row.wrntPeriod"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "align-right",
                                                              staticStyle: {
                                                                "background-color":
                                                                  "#edd28b",
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text",
                                                                title:
                                                                  rows.row
                                                                    .validateInfo
                                                                    .wrntPeriod
                                                                    .errorMsg
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .wrntPeriod
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.commonChangeEvent,
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "wrntPeriod",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          : _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .wrntPeriod,
                                                                  expression:
                                                                    "rows.row.wrntPeriod"
                                                                }
                                                              ],
                                                              staticClass:
                                                                "align-right",
                                                              staticStyle: {
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .wrntPeriod
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.commonChangeEvent,
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "wrntPeriod",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "bizFormNames",
                                        null,
                                        _vm.asmblCustFileds,
                                        _vm.asmblFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "bizFormNames",
                                                  "经营业态",
                                                  _vm.asmblFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: {
                                                  prop: "bizFormNames",
                                                  "render-header":
                                                    _vm.setBizFormNames
                                                },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .bizFormNames
                                                          .validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .bizFormNames
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .bizFormNames
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row
                                                                    .bizFormNames
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              props.row.feeItemImpInfos != null &&
                              props.row.feeItemImpInfos.length > 0
                                ? _c(
                                    "el-table",
                                    {
                                      staticStyle: {
                                        width: "100%",
                                        "margin-top": "5px"
                                      },
                                      attrs: {
                                        data: props.row.feeItemImpInfos,
                                        border: "",
                                        "row-class-name":
                                          _vm.markSelectedRowClassName
                                      },
                                      on: {
                                        "selection-change":
                                          _vm.handleSelectionChange
                                      }
                                    },
                                    [
                                      _c("el-table-column", {
                                        attrs: {
                                          type: "selection",
                                          width: "40",
                                          align: "center",
                                          fixed: "left"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "htBh",
                                        null,
                                        _vm.feeCustFileds,
                                        _vm.feeFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "htBh",
                                                  "合同编号",
                                                  _vm.feeFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: { prop: "htBh" },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .htBh.validateOk
                                                          ? _c(
                                                              "div",
                                                              {
                                                                staticStyle: {
                                                                  "background-color":
                                                                    "#edd28b",
                                                                  width: "100%",
                                                                  height: "100%"
                                                                },
                                                                attrs: {
                                                                  title:
                                                                    rows.row
                                                                      .validateInfo
                                                                      .htBh
                                                                      .errorMsg
                                                                }
                                                              },
                                                              [
                                                                _c("span", [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      rows.row
                                                                        .htBh
                                                                    )
                                                                  )
                                                                ])
                                                              ]
                                                            )
                                                          : _c("div", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  rows.row.htBh
                                                                )
                                                              )
                                                            ])
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "feeTypeText",
                                        null,
                                        _vm.feeCustFileds,
                                        _vm.feeFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "feeTypeText",
                                                  "费用类型",
                                                  _vm.feeFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: { prop: "innerCode" },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        _c(
                                                          "el-select",
                                                          {
                                                            attrs: {
                                                              placeholder:
                                                                "请选择"
                                                            },
                                                            on: {
                                                              change:
                                                                _vm.commonChangeEvent
                                                            },
                                                            model: {
                                                              value:
                                                                rows.row
                                                                  .feeTypeText,
                                                              callback: function(
                                                                $$v
                                                              ) {
                                                                _vm.$set(
                                                                  rows.row,
                                                                  "feeTypeText",
                                                                  $$v
                                                                )
                                                              },
                                                              expression:
                                                                "rows.row.feeTypeText"
                                                            }
                                                          },
                                                          _vm._l(
                                                            _vm.purchFeeTypeList,
                                                            function(
                                                              purchFeeType
                                                            ) {
                                                              return _c(
                                                                "el-option",
                                                                {
                                                                  key:
                                                                    purchFeeType.value,
                                                                  attrs: {
                                                                    label:
                                                                      purchFeeType.text,
                                                                    value:
                                                                      purchFeeType.text
                                                                  }
                                                                }
                                                              )
                                                            }
                                                          )
                                                        )
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "feeName",
                                        null,
                                        _vm.feeCustFileds,
                                        _vm.feeFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "feeName",
                                                  "名称",
                                                  _vm.feeFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: { prop: "name" },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .feeName.validateOk
                                                          ? _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .feeName,
                                                                  expression:
                                                                    "rows.row.feeName"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                "background-color":
                                                                  "#edd28b",
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text",
                                                                title:
                                                                  rows.row
                                                                    .validateInfo
                                                                    .feeName
                                                                    .errorMsg
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .feeName
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "feeName",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          : _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .feeName,
                                                                  expression:
                                                                    "rows.row.feeName"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .feeName
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.commonChangeEvent,
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "feeName",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "feeBrandName",
                                        null,
                                        _vm.feeCustFileds,
                                        _vm.feeFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "feeBrandName",
                                                  "品牌",
                                                  _vm.feeFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: { prop: "assetTitle" },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .feeBrandName
                                                          .validateOk
                                                          ? _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .feeBrandName,
                                                                  expression:
                                                                    "rows.row.feeBrandName"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                "background-color":
                                                                  "#edd28b",
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text",
                                                                title:
                                                                  rows.row
                                                                    .validateInfo
                                                                    .feeBrandName
                                                                    .errorMsg
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .feeBrandName
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "feeBrandName",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          : _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .feeBrandName,
                                                                  expression:
                                                                    "rows.row.feeBrandName"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .feeBrandName
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.commonChangeEvent,
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "feeBrandName",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "feeModelSpec",
                                        null,
                                        _vm.feeCustFileds,
                                        _vm.feeFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "feeModelSpec",
                                                  "规格",
                                                  _vm.feeFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: { prop: "brandName" },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .feeModelSpec
                                                          .validateOk
                                                          ? _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .feeModelSpec,
                                                                  expression:
                                                                    "rows.row.feeModelSpec"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                "background-color":
                                                                  "#edd28b",
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text",
                                                                title:
                                                                  rows.row
                                                                    .validateInfo
                                                                    .feeModelSpec
                                                                    .errorMsg
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .feeModelSpec
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "feeModelSpec",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          : _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .feeModelSpec,
                                                                  expression:
                                                                    "rows.row.feeModelSpec"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .feeModelSpec
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.commonChangeEvent,
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "feeModelSpec",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "feeUnit",
                                        null,
                                        _vm.feeCustFileds,
                                        _vm.feeFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "feeUnit",
                                                  "单位",
                                                  _vm.feeFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: { prop: "theUnit" },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .feeUnit.validateOk
                                                          ? _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .feeUnit,
                                                                  expression:
                                                                    "rows.row.feeUnit"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                "background-color":
                                                                  "#edd28b",
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text",
                                                                title:
                                                                  rows.row
                                                                    .validateInfo
                                                                    .feeUnit
                                                                    .errorMsg
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .feeUnit
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "feeUnit",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          : _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .feeUnit,
                                                                  expression:
                                                                    "rows.row.feeUnit"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "text"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .feeUnit
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.commonChangeEvent,
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "feeUnit",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.viewFieldFlag(
                                        "feePrice",
                                        null,
                                        _vm.feeCustFileds,
                                        _vm.feeFieldMap
                                      )
                                        ? _c(
                                            "el-table-column",
                                            {
                                              attrs: {
                                                label: _vm.getFieldTitle(
                                                  "feePrice",
                                                  "单价(元)",
                                                  _vm.feeFieldMap
                                                )
                                              }
                                            },
                                            [
                                              _c("el-table-column", {
                                                attrs: { prop: "model" },
                                                scopedSlots: _vm._u([
                                                  {
                                                    key: "default",
                                                    fn: function(rows) {
                                                      return [
                                                        !rows.row.validateInfo
                                                          .feePrice.validateOk
                                                          ? _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .feePrice,
                                                                  expression:
                                                                    "rows.row.feePrice"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                "background-color":
                                                                  "#edd28b",
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "number",
                                                                title:
                                                                  rows.row
                                                                    .validateInfo
                                                                    .feePrice
                                                                    .errorMsg
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .feePrice
                                                              },
                                                              on: {
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "feePrice",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                          : _c("input", {
                                                              directives: [
                                                                {
                                                                  name: "model",
                                                                  rawName:
                                                                    "v-model",
                                                                  value:
                                                                    rows.row
                                                                      .feePrice,
                                                                  expression:
                                                                    "rows.row.feePrice"
                                                                }
                                                              ],
                                                              staticStyle: {
                                                                width: "98%"
                                                              },
                                                              attrs: {
                                                                type: "number"
                                                              },
                                                              domProps: {
                                                                value:
                                                                  rows.row
                                                                    .feePrice
                                                              },
                                                              on: {
                                                                change:
                                                                  _vm.commonChangeEvent,
                                                                input: function(
                                                                  $event
                                                                ) {
                                                                  if (
                                                                    $event
                                                                      .target
                                                                      .composing
                                                                  ) {
                                                                    return
                                                                  }
                                                                  _vm.$set(
                                                                    rows.row,
                                                                    "feePrice",
                                                                    $event
                                                                      .target
                                                                      .value
                                                                  )
                                                                }
                                                              }
                                                            })
                                                      ]
                                                    }
                                                  }
                                                ])
                                              })
                                            ],
                                            1
                                          )
                                        : _vm._e()
                                    ],
                                    1
                                  )
                                : _vm._e()
                            ],
                            1
                          )
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    type: "selection",
                    width: "40",
                    align: "center",
                    fixed: "left"
                  }
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  attrs: {
                    label: "行号",
                    prop: "rowNo",
                    width: "60",
                    align: "center"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          rows.row.virtualRow
                            ? _c("span", { staticClass: "font-gray3" }, [
                                _vm._v("虚拟行")
                              ])
                            : _c("span", [_vm._v(_vm._s(rows.row.rowNo))])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.startFlag,
                      expression: "startFlag"
                    }
                  ],
                  attrs: {
                    prop: "failed",
                    label: "执行状态",
                    width: "60",
                    align: "center"
                  },
                  scopedSlots: _vm._u([
                    {
                      key: "default",
                      fn: function(rows) {
                        return [
                          rows.row.failed != null
                            ? _c("div", [
                                rows.row.failed
                                  ? _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "red",
                                          "font-size": "20px"
                                        }
                                      },
                                      [_vm._v("×")]
                                    )
                                  : _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          color: "green",
                                          "font-size": "20px"
                                        }
                                      },
                                      [_vm._v("√")]
                                    )
                              ])
                            : _c("span", { staticClass: "font-gray3" }, [
                                _vm._v("未执行")
                              ])
                        ]
                      }
                    }
                  ])
                }),
                _vm._v(" "),
                _c("el-table-column", {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.startFlag,
                      expression: "startFlag"
                    }
                  ],
                  attrs: { prop: "failDesc", label: "失败描述", align: "left" }
                }),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "fstPartyRealComName",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c(
                      "el-table-column",
                      {
                        attrs: {
                          label: _vm.getFieldTitle(
                            "fstPartyRealComName",
                            "买方公司",
                            _vm.contractFieldMap
                          )
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "fstPartyRealComName",
                            "render-header": _vm.setFstPartyRealComInfo
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  !rows.row.validateInfo.fstPartyRealComName
                                    .validateOk
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "background-color": "#edd28b",
                                            width: "100%",
                                            height: "100%"
                                          },
                                          attrs: {
                                            title:
                                              rows.row.validateInfo
                                                .fstPartyRealComName.errorMsg
                                          }
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                rows.row.fstPartyRealComName
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(rows.row.fstPartyRealComName)
                                        )
                                      ])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "title",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c("el-table-column", {
                      attrs: {
                        label: _vm.getFieldTitle(
                          "title",
                          "合同名称",
                          _vm.contractFieldMap
                        ),
                        prop: "title",
                        width: "200"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              !rows.row.validateInfo.title.validateOk
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: rows.row.title,
                                        expression: "rows.row.title"
                                      }
                                    ],
                                    staticStyle: {
                                      "background-color": "#edd28b",
                                      width: "98%"
                                    },
                                    attrs: {
                                      type: "text",
                                      disabled: rows.row.virtualRow,
                                      title:
                                        rows.row.validateInfo.title.errorMsg
                                    },
                                    domProps: { value: rows.row.title },
                                    on: {
                                      change: _vm.commonChangeEvent,
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          rows.row,
                                          "title",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                : _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: rows.row.title,
                                        expression: "rows.row.title"
                                      }
                                    ],
                                    staticStyle: { width: "98%" },
                                    attrs: {
                                      type: "text",
                                      disabled: rows.row.virtualRow
                                    },
                                    domProps: { value: rows.row.title },
                                    on: {
                                      change: _vm.commonChangeEvent,
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          rows.row,
                                          "title",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                            ]
                          }
                        }
                      ])
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "htBh",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c("el-table-column", {
                      attrs: {
                        label: _vm.getFieldTitle(
                          "htBh",
                          "合同编号",
                          _vm.contractFieldMap
                        ),
                        prop: "htBh",
                        width: "200"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              !rows.row.validateInfo.htBh.validateOk
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "background-color": "#edd28b",
                                        width: "100%",
                                        height: "100%"
                                      },
                                      attrs: {
                                        title:
                                          rows.row.validateInfo.htBh.errorMsg
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(rows.row.htBh))
                                      ])
                                    ]
                                  )
                                : _c("div", [_vm._v(_vm._s(rows.row.htBh))])
                            ]
                          }
                        }
                      ])
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "sndPartyName",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c("el-table-column", {
                      attrs: {
                        label: _vm.getFieldTitle(
                          "sndPartyName",
                          "供应商名称",
                          _vm.contractFieldMap
                        ),
                        prop: "sndPartyName",
                        width: "200"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              !rows.row.validateInfo.sndPartyName.validateOk
                                ? _c(
                                    "div",
                                    {
                                      staticStyle: {
                                        "background-color": "#edd28b",
                                        width: "100%",
                                        height: "100%"
                                      },
                                      attrs: {
                                        title:
                                          rows.row.validateInfo.sndPartyName
                                            .errorMsg
                                      }
                                    },
                                    [
                                      _c("span", [
                                        _vm._v(_vm._s(rows.row.sndPartyName))
                                      ])
                                    ]
                                  )
                                : _c("div", [
                                    _vm._v(_vm._s(rows.row.sndPartyName))
                                  ])
                            ]
                          }
                        }
                      ])
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "sndPartyRealComName",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c(
                      "el-table-column",
                      {
                        attrs: {
                          label: _vm.getFieldTitle(
                            "sndPartyRealComName",
                            "卖方公司",
                            _vm.contractFieldMap
                          )
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "sndPartyRealComName",
                            "render-header": _vm.setSndPartyRealComInfo
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  !rows.row.validateInfo.sndPartyRealComName
                                    .validateOk
                                    ? _c(
                                        "div",
                                        {
                                          staticStyle: {
                                            "background-color": "#edd28b",
                                            width: "100%",
                                            height: "100%"
                                          },
                                          attrs: {
                                            title:
                                              rows.row.validateInfo
                                                .sndPartyRealComName.errorMsg
                                          }
                                        },
                                        [
                                          _c("span", [
                                            _vm._v(
                                              _vm._s(
                                                rows.row.sndPartyRealComName
                                              )
                                            )
                                          ])
                                        ]
                                      )
                                    : _c("span", [
                                        _vm._v(
                                          _vm._s(rows.row.sndPartyRealComName)
                                        )
                                      ])
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "sndPartyNo",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c("el-table-column", {
                      attrs: {
                        label: _vm.getFieldTitle(
                          "sndPartyNo",
                          "供应商统一社会信用代码",
                          _vm.contractFieldMap
                        ),
                        prop: "sndPartyNo",
                        width: "200"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              !rows.row.validateInfo.sndPartyNo.validateOk
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: rows.row.sndPartyNo,
                                        expression: "rows.row.sndPartyNo"
                                      }
                                    ],
                                    staticStyle: {
                                      "background-color": "#edd28b",
                                      width: "98%"
                                    },
                                    attrs: {
                                      type: "text",
                                      disabled:
                                        rows.row.virtualRow ||
                                        _vm.fileObj.extra.updateFlag,
                                      title:
                                        rows.row.validateInfo.sndPartyNo
                                          .errorMsg
                                    },
                                    domProps: { value: rows.row.sndPartyNo },
                                    on: {
                                      change: function($event) {
                                        _vm.vendorChangeEvent(rows.row)
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          rows.row,
                                          "sndPartyNo",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                : _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: rows.row.sndPartyNo,
                                        expression: "rows.row.sndPartyNo"
                                      }
                                    ],
                                    staticStyle: { width: "98%" },
                                    attrs: {
                                      type: "text",
                                      disabled:
                                        rows.row.virtualRow ||
                                        _vm.fileObj.extra.updateFlag
                                    },
                                    domProps: { value: rows.row.sndPartyNo },
                                    on: {
                                      change: function($event) {
                                        _vm.vendorChangeEvent(rows.row)
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          rows.row,
                                          "sndPartyNo",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                            ]
                          }
                        }
                      ])
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "dateStart",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c("el-table-column", {
                      attrs: {
                        label: _vm.getFieldTitle(
                          "dateStart",
                          "开始时间",
                          _vm.contractFieldMap
                        ),
                        prop: "dateStart",
                        width: "140"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("el-date-picker", {
                                staticStyle: { width: "95%" },
                                attrs: {
                                  type: "date",
                                  placeholder: "选择日期",
                                  "value-format": "yyyy-MM-dd"
                                },
                                on: { change: _vm.commonChangeEvent },
                                model: {
                                  value: rows.row.dateStart,
                                  callback: function($$v) {
                                    _vm.$set(rows.row, "dateStart", $$v)
                                  },
                                  expression: "rows.row.dateStart"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "dateEnd",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c("el-table-column", {
                      attrs: {
                        label: _vm.getFieldTitle(
                          "dateEnd",
                          "结束时间",
                          _vm.contractFieldMap
                        ),
                        prop: "dateEnd",
                        width: "140"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("el-date-picker", {
                                staticStyle: { width: "95%" },
                                attrs: {
                                  type: "date",
                                  placeholder: "选择日期",
                                  "value-format": "yyyy-MM-dd"
                                },
                                on: { change: _vm.commonChangeEvent },
                                model: {
                                  value: rows.row.dateEnd,
                                  callback: function($$v) {
                                    _vm.$set(rows.row, "dateEnd", $$v)
                                  },
                                  expression: "rows.row.dateEnd"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "signDate",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c("el-table-column", {
                      attrs: {
                        label: _vm.getFieldTitle(
                          "signDate",
                          "签署日期",
                          _vm.contractFieldMap
                        ),
                        prop: "signDate",
                        width: "140"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("el-date-picker", {
                                staticStyle: { width: "95%" },
                                attrs: {
                                  type: "date",
                                  placeholder: "选择日期",
                                  "value-format": "yyyy-MM-dd"
                                },
                                on: { change: _vm.commonChangeEvent },
                                model: {
                                  value: rows.row.signDate,
                                  callback: function($$v) {
                                    _vm.$set(rows.row, "signDate", $$v)
                                  },
                                  expression: "rows.row.signDate"
                                }
                              })
                            ]
                          }
                        }
                      ])
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "desireArriveDays",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c("el-table-column", {
                      attrs: {
                        label: _vm.getFieldTitle(
                          "desireArriveDays",
                          "到货期限(天)",
                          _vm.contractFieldMap
                        ),
                        prop: "desireArriveDays",
                        width: "140"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              !rows.row.validateInfo.desireArriveDays.validateOk
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: rows.row.desireArriveDays,
                                        expression: "rows.row.desireArriveDays"
                                      }
                                    ],
                                    staticClass: "align-right",
                                    staticStyle: {
                                      "background-color": "#edd28b",
                                      width: "90px"
                                    },
                                    attrs: {
                                      type: "number",
                                      size: "6",
                                      min: 0,
                                      max: 100000,
                                      title:
                                        rows.row.validateInfo.desireArriveDays
                                          .errorMsg
                                    },
                                    domProps: {
                                      value: rows.row.desireArriveDays
                                    },
                                    on: {
                                      change: _vm.commonChangeEvent,
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          rows.row,
                                          "desireArriveDays",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                : _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: rows.row.desireArriveDays,
                                        expression: "rows.row.desireArriveDays"
                                      }
                                    ],
                                    staticClass: "align-right",
                                    staticStyle: { width: "90px" },
                                    attrs: {
                                      type: "number",
                                      size: "6",
                                      min: 0,
                                      max: 100000
                                    },
                                    domProps: {
                                      value: rows.row.desireArriveDays
                                    },
                                    on: {
                                      change: _vm.commonChangeEvent,
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          rows.row,
                                          "desireArriveDays",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                            ]
                          }
                        }
                      ])
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "taxRate",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c("el-table-column", {
                      attrs: {
                        label: _vm.getFieldTitle(
                          "taxRate",
                          "税率(%)",
                          _vm.contractFieldMap
                        ),
                        prop: "taxRate",
                        width: "120",
                        align: "right"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              !rows.row.validateInfo.taxRate.validateOk
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: rows.row.taxRate,
                                        expression: "rows.row.taxRate"
                                      }
                                    ],
                                    staticClass: "align-right",
                                    staticStyle: {
                                      "background-color": "#edd28b",
                                      width: "98%"
                                    },
                                    attrs: {
                                      type: "text",
                                      disabled: rows.row.virtualRow,
                                      title:
                                        rows.row.validateInfo.taxRate.errorMsg
                                    },
                                    domProps: { value: rows.row.taxRate },
                                    on: {
                                      change: _vm.commonChangeEvent,
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          rows.row,
                                          "taxRate",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                : _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: rows.row.taxRate,
                                        expression: "rows.row.taxRate"
                                      }
                                    ],
                                    staticClass: "align-right",
                                    staticStyle: { width: "98%" },
                                    attrs: {
                                      type: "text",
                                      disabled: rows.row.virtualRow
                                    },
                                    domProps: { value: rows.row.taxRate },
                                    on: {
                                      change: _vm.commonChangeEvent,
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          rows.row,
                                          "taxRate",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                            ]
                          }
                        }
                      ])
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "payPhaseTplName",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c("el-table-column", {
                      attrs: {
                        label: _vm.getFieldTitle(
                          "payPhaseTplName",
                          "付款阶段模板",
                          _vm.contractFieldMap
                        ),
                        prop: "payPhaseTplName",
                        width: "200"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c("div", [
                                _vm._v(_vm._s(rows.row.payPhaseTplName))
                              ])
                            ]
                          }
                        }
                      ])
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "invoiceTypeText",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c("el-table-column", {
                      attrs: {
                        label: _vm.getFieldTitle(
                          "invoiceType",
                          "发票类型",
                          _vm.contractFieldMap
                        ),
                        prop: "invoiceType",
                        width: "130"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              _c(
                                "el-select",
                                {
                                  attrs: { placeholder: "请选择" },
                                  on: {
                                    change: function($event) {
                                      _vm.invoiceTypeChange(rows.row)
                                    }
                                  },
                                  model: {
                                    value: rows.row.invoiceType,
                                    callback: function($$v) {
                                      _vm.$set(rows.row, "invoiceType", $$v)
                                    },
                                    expression: "rows.row.invoiceType"
                                  }
                                },
                                _vm._l(_vm.invoiceTypeList, function(
                                  invoiceType
                                ) {
                                  return _c("el-option", {
                                    key: invoiceType.value,
                                    attrs: {
                                      label: invoiceType.text,
                                      value: invoiceType.value
                                    }
                                  })
                                })
                              )
                            ]
                          }
                        }
                      ])
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "invoiceTitle",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c("el-table-column", {
                      attrs: {
                        label: _vm.getFieldTitle(
                          "invoiceTitle",
                          "发票抬头",
                          _vm.contractFieldMap
                        ),
                        prop: "invoiceTitle",
                        width: "200"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              !rows.row.validateInfo.invoiceTitle.validateOk
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: rows.row.invoiceTitle,
                                        expression: "rows.row.invoiceTitle"
                                      }
                                    ],
                                    staticClass: "align-left",
                                    staticStyle: {
                                      "background-color": "#edd28b",
                                      width: "98%"
                                    },
                                    attrs: {
                                      type: "text",
                                      disabled: rows.row.virtualRow,
                                      title:
                                        rows.row.validateInfo.invoiceTitle
                                          .errorMsg
                                    },
                                    domProps: { value: rows.row.invoiceTitle },
                                    on: {
                                      change: _vm.commonChangeEvent,
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          rows.row,
                                          "invoiceTitle",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                : _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: rows.row.invoiceTitle,
                                        expression: "rows.row.invoiceTitle"
                                      }
                                    ],
                                    staticClass: "align-left",
                                    staticStyle: { width: "98%" },
                                    attrs: {
                                      type: "text",
                                      disabled: rows.row.virtualRow
                                    },
                                    domProps: { value: rows.row.invoiceTitle },
                                    on: {
                                      change: _vm.commonChangeEvent,
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          rows.row,
                                          "invoiceTitle",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                            ]
                          }
                        }
                      ])
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "invoiceContentTag",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c("el-table-column", {
                      attrs: {
                        label: _vm.getFieldTitle(
                          "invoiceContentTag",
                          "发票内容标签",
                          _vm.contractFieldMap
                        ),
                        prop: "invoiceContentTag",
                        width: "200"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              !rows.row.validateInfo.invoiceContentTag
                                .validateOk
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: rows.row.invoiceContentTag,
                                        expression: "rows.row.invoiceContentTag"
                                      }
                                    ],
                                    staticClass: "align-left",
                                    staticStyle: {
                                      "background-color": "#edd28b",
                                      width: "98%"
                                    },
                                    attrs: {
                                      type: "text",
                                      disabled: rows.row.virtualRow,
                                      title:
                                        rows.row.validateInfo.invoiceContentTag
                                          .errorMsg
                                    },
                                    domProps: {
                                      value: rows.row.invoiceContentTag
                                    },
                                    on: {
                                      change: _vm.commonChangeEvent,
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          rows.row,
                                          "invoiceContentTag",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                : _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: rows.row.invoiceContentTag,
                                        expression: "rows.row.invoiceContentTag"
                                      }
                                    ],
                                    staticClass: "align-left",
                                    staticStyle: { width: "98%" },
                                    attrs: {
                                      type: "text",
                                      disabled: rows.row.virtualRow
                                    },
                                    domProps: {
                                      value: rows.row.invoiceContentTag
                                    },
                                    on: {
                                      change: _vm.commonChangeEvent,
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          rows.row,
                                          "invoiceContentTag",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                            ]
                          }
                        }
                      ])
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "taxPayerNo",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c("el-table-column", {
                      attrs: {
                        label: _vm.getFieldTitle(
                          "taxPayerNo",
                          "纳税人识别号",
                          _vm.contractFieldMap
                        ),
                        prop: "taxPayerNo",
                        width: "200"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              !rows.row.validateInfo.taxPayerNo.validateOk
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: rows.row.taxPayerNo,
                                        expression: "rows.row.taxPayerNo"
                                      }
                                    ],
                                    staticClass: "align-left",
                                    staticStyle: {
                                      "background-color": "#edd28b",
                                      width: "98%"
                                    },
                                    attrs: {
                                      type: "text",
                                      disabled: rows.row.virtualRow,
                                      title:
                                        rows.row.validateInfo.taxPayerNo
                                          .errorMsg
                                    },
                                    domProps: { value: rows.row.taxPayerNo },
                                    on: {
                                      change: _vm.commonChangeEvent,
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          rows.row,
                                          "taxPayerNo",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                : _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: rows.row.taxPayerNo,
                                        expression: "rows.row.taxPayerNo"
                                      }
                                    ],
                                    staticClass: "align-left",
                                    staticStyle: { width: "98%" },
                                    attrs: {
                                      type: "text",
                                      disabled: rows.row.virtualRow
                                    },
                                    domProps: { value: rows.row.taxPayerNo },
                                    on: {
                                      change: _vm.commonChangeEvent,
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          rows.row,
                                          "taxPayerNo",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                            ]
                          }
                        }
                      ])
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "signGroupName",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c("el-table-column", {
                      attrs: {
                        label: _vm.getFieldTitle(
                          "signGroupName",
                          "合同适用范围",
                          _vm.contractFieldMap
                        ),
                        prop: "signGroupName",
                        width: "200"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              !rows.row.validateInfo.signGroupName.validateOk
                                ? _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: rows.row.signGroupName,
                                        expression: "rows.row.signGroupName"
                                      }
                                    ],
                                    staticClass: "align-left",
                                    staticStyle: {
                                      "background-color": "#edd28b",
                                      width: "98%"
                                    },
                                    attrs: {
                                      type: "text",
                                      disabled: rows.row.virtualRow,
                                      title:
                                        rows.row.validateInfo.signGroupName
                                          .errorMsg
                                    },
                                    domProps: { value: rows.row.signGroupName },
                                    on: {
                                      change: _vm.commonChangeEvent,
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          rows.row,
                                          "signGroupName",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                : _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: rows.row.signGroupName,
                                        expression: "rows.row.signGroupName"
                                      }
                                    ],
                                    staticClass: "align-left",
                                    staticStyle: { width: "98%" },
                                    attrs: {
                                      type: "text",
                                      disabled: rows.row.virtualRow
                                    },
                                    domProps: { value: rows.row.signGroupName },
                                    on: {
                                      change: _vm.commonChangeEvent,
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          rows.row,
                                          "signGroupName",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                            ]
                          }
                        }
                      ])
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "taxOffset",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c("el-table-column", {
                      staticClass: "align-center",
                      attrs: {
                        label: _vm.getFieldTitle(
                          "taxOffset",
                          "购置可抵税",
                          _vm.contractFieldMap
                        ),
                        prop: "taxOffset",
                        width: "100"
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(rows) {
                            return [
                              rows.row.taxOffset
                                ? _c("span", [_vm._v("是")])
                                : _c("span", [_vm._v("否")])
                            ]
                          }
                        }
                      ])
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "settleCrossOrderAllowed",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c(
                      "el-table-column",
                      {
                        attrs: {
                          label: _vm.getFieldTitle(
                            "settleCrossOrderAllowed",
                            "跨订单结算",
                            _vm.contractFieldMap
                          ),
                          align: "center"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "settleCrossOrderAllowed",
                            width: "70",
                            align: "center"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: rows.row.settleCrossOrderAllowed,
                                        expression:
                                          "rows.row.settleCrossOrderAllowed"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        rows.row.settleCrossOrderAllowed
                                      )
                                        ? _vm._i(
                                            rows.row.settleCrossOrderAllowed,
                                            null
                                          ) > -1
                                        : rows.row.settleCrossOrderAllowed
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a =
                                              rows.row.settleCrossOrderAllowed,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  rows.row,
                                                  "settleCrossOrderAllowed",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  rows.row,
                                                  "settleCrossOrderAllowed",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              rows.row,
                                              "settleCrossOrderAllowed",
                                              $$c
                                            )
                                          }
                                        },
                                        function($event) {
                                          _vm.commonChangeEvent(rows.row)
                                        }
                                      ]
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "settleAutoFlag",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c(
                      "el-table-column",
                      {
                        attrs: {
                          label: _vm.getFieldTitle(
                            "settleAutoFlag",
                            "自动结算",
                            _vm.contractFieldMap
                          ),
                          align: "center"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "settleAutoFlag",
                            width: "70",
                            align: "center"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: rows.row.settleAutoFlag,
                                        expression: "rows.row.settleAutoFlag"
                                      }
                                    ],
                                    attrs: { type: "checkbox" },
                                    domProps: {
                                      checked: Array.isArray(
                                        rows.row.settleAutoFlag
                                      )
                                        ? _vm._i(
                                            rows.row.settleAutoFlag,
                                            null
                                          ) > -1
                                        : rows.row.settleAutoFlag
                                    },
                                    on: {
                                      change: [
                                        function($event) {
                                          var $$a = rows.row.settleAutoFlag,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = null,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                _vm.$set(
                                                  rows.row,
                                                  "settleAutoFlag",
                                                  $$a.concat([$$v])
                                                )
                                            } else {
                                              $$i > -1 &&
                                                _vm.$set(
                                                  rows.row,
                                                  "settleAutoFlag",
                                                  $$a
                                                    .slice(0, $$i)
                                                    .concat($$a.slice($$i + 1))
                                                )
                                            }
                                          } else {
                                            _vm.$set(
                                              rows.row,
                                              "settleAutoFlag",
                                              $$c
                                            )
                                          }
                                        },
                                        function($event) {
                                          _vm.commonChangeEvent(rows.row)
                                        }
                                      ]
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewFieldFlag(
                  "settlePeriodDay",
                  null,
                  _vm.contractCustFileds,
                  _vm.contractFieldMap
                )
                  ? _c(
                      "el-table-column",
                      {
                        attrs: {
                          label: _vm.getFieldTitle(
                            "settlePeriodDay",
                            "结算周期(每月x号)",
                            _vm.contractFieldMap
                          ),
                          align: "center"
                        }
                      },
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "settlePeriodDay",
                            width: "70",
                            align: "center"
                          },
                          scopedSlots: _vm._u([
                            {
                              key: "default",
                              fn: function(rows) {
                                return [
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: rows.row.settlePeriodDay,
                                        expression: "rows.row.settlePeriodDay"
                                      }
                                    ],
                                    staticClass: "align-right",
                                    staticStyle: { width: "90px" },
                                    attrs: {
                                      type: "number",
                                      size: "6",
                                      min: 1,
                                      max: 28
                                    },
                                    domProps: {
                                      value: rows.row.settlePeriodDay
                                    },
                                    on: {
                                      change: function($event) {
                                        _vm.commonChangeEvent(rows.row)
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.$set(
                                          rows.row,
                                          "settlePeriodDay",
                                          $event.target.value
                                        )
                                      }
                                    }
                                  })
                                ]
                              }
                            }
                          ])
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          ],
          1
        )
      : _vm._e(),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "clearfix" },
      [
        _vm.totalCount > 0
          ? _c("el-pagination", {
              staticClass: "fl mt5",
              attrs: {
                background: "",
                "page-size": _vm.pageSize,
                "page-sizes": _vm.pageSizes,
                "current-page": _vm.pageNumber,
                total: _vm.totalCount,
                layout: "prev, pager, next, jumper, sizes, total"
              },
              on: {
                "current-change": _vm.handlePageChange,
                "size-change": _vm.handleSizeChange
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "swb-btn swb-btn-small fr mt10",
            on: { click: _vm.downloadContractImpModel }
          },
          [_vm._v("导出全部合同")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "swb-btn swb-btn-small fr mt10 mr10",
            on: { click: _vm.doContractImpModelImport }
          },
          [_vm._v("执行导入")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "swb-btn swb-btn-small fr mt10 mr10",
            on: {
              click: function($event) {
                _vm.validateContractImpModel(true)
              }
            }
          },
          [_vm._v("逐条检查")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-16b21c74", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16b21c74","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/contract/ContractImpCheck.vue
// module id = 3235
// module chunks = 0